import API from '../../lib/api';
import types from './types';

export const loadTasks = () => async dispatch => {
    const response = await API.call({
        path: "/tasks/get"
    });

    if(response.success)
        dispatch({
            type: types.loaded,
            payload: response.tasks
        });
}